import ExecutionEnvironment from 'exenv';

import { AppState } from 'types/app';

export const selectCookies = (state: AppState) => state.cookies;

export const selectCookie = (state: AppState, key: string): string => selectCookies(state)[key] || '';

export const selectIsCustomer = (state: AppState) => !!(ExecutionEnvironment.canUseDOM && selectCookie(state, 'x-main'));
